import {toAbsoluteUrl} from '../helpers'

export const LANGUAGE_KEY = {
  EN: 'en',
  ZH: 'zh',
  JA: 'ja',
}

export const LanguageConfig = () => {
  return {
    LANGUAGES: [
      {
        value: LANGUAGE_KEY.EN,
        flag: toAbsoluteUrl('/media/flags/united-states.svg'),
        label: 'ENGLISH',
      },
      {
        value: LANGUAGE_KEY.ZH,
        flag: toAbsoluteUrl('/media/flags/china.svg'),
        label: 'CHINESE',
      },
      {
        value: LANGUAGE_KEY.JA,
        label: 'JAPANESE',
        flag: toAbsoluteUrl('/media/flags/japan.svg'),
      },
    ],
  }
}
